import React from 'react';
import { Box, HStack, Spacer, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export const NoticeMessageListHeader: React.FC = () => {
  return (
    <HStack h={12} bgColor='gray.800' color='white'>
      <Text mr={10} color='silver' ml='10' fontSize='16'>
        {'メッセージ一覧'}
      </Text>
      <Spacer />
      <Box
        textAlign='right'
        fontSize='14'
        bg='transparent'
        _hover={{ bg: 'gray', color: 'white' }}
        color='silver'
      >
        <Link to='/location'>閉じる</Link>
      </Box>
    </HStack>
  );
};
